import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Permission, RoleType } from '@bookly/shared';

import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (
  route,
  // eslint-disable-next-line
  state
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = route.data['role'] as RoleType | RoleType[];
  const requiredPermissions = route.data['permissions'] as Permission[] | null;
  const rolesArray = Array.isArray(requiredRoles)
    ? requiredRoles
    : [requiredRoles];
  const hasAccess = !requiredPermissions
    ? rolesArray.some(role => authService.hasRole(role))
    : rolesArray.some(role =>
        authService.hasPermissionsInRole(role, requiredPermissions)
      );
  if (hasAccess) {
    return true;
  }
  return router.createUrlTree(['/']);
};
